import {
  laptopMediumMax,
  mobileLargeMax,
  mobileMax,
  mobileXXLargeMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import ShowHomesBg from '@propertypal/shared/src/resources/bg/show-homes-bg.jpg';
import styled from 'styled-components';
import { MAX_WIDTH } from '../layout/PageWrapper.style';

export const Container = styled.div`
  background-image: url(${ShowHomesBg.src});
  background-position: 10%;
  background-size: cover;
  width: 100%;
  margin: 30px auto;
  height: 750px;
  padding: 120px 0 0;

  @media (${laptopMediumMax}) {
    height: 550px;
  }

  @media (${mobileXXLargeMax}) {
    background-position: 30%;
  }

  @media (${mobileMax}) {
    padding: 40px 0 85px 0;
    height: auto;
    background-position: 35%;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  margin: 0 auto;
  padding: 0 30px;

  @media (${mobileMax}) {
    padding: 0 15px;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 530px;

  h2 {
    color: ${(props) => props.theme.white};
    font-size: 64px;
    font-weight: bold;
    line-height: 1;
    margin-top: 20px;
  }

  h3 {
    color: ${(props) => props.theme.white};
    font-size: 28px;
    font-weight: 600;
    margin-top: 40px;
  }

  @media (${laptopMediumMax}) {
    h2 {
      font-size: 42px;
      max-width: 70%;
    }

    h3 {
      font-size: 20px;
      margin-top: 10px;
      max-width: 60%;
    }
  }

  @media (${mobileLargeMax}) {
    h2 {
      font-size: 34px;
    }

    h3 {
      max-width: 60%;
    }
  }
`;

export const Benefits = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 100px;
`;

export const Benefit = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(33% - 10px);
  margin-top: 60px;

  @media (${laptopMediumMax}) {
    max-width: none;
    width: calc(50% - 20px);
  }

  @media (${mobileXXLargeMax}) {
    width: 100%;
  }

  svg {
    height: 64px;
    align-self: flex-start;
  }

  h4 {
    margin-top: 20px;
    font-size: 22px;
    color: ${(props) => props.theme.textDark};
  }

  p {
    margin-top: 15px;
    font-size: 16px;
    color: ${(props) => props.theme.textDark};
  }
`;
